import moment from 'moment/moment';

export const TIME_FORMAT_HUMAN_READABLE_FULL = 'LLL';
export const TIME_FORMAT_HUMAN_READABLE_SHORT = 'YY-MMM-DD hh:ss A';

export const formatTimestamp = (timestamp, options = {}) => {
  const { format = TIME_FORMAT_HUMAN_READABLE_FULL } = options;
  return moment(`${timestamp}Z`).format(format);
};
